import { createFilterTransfer } from './common';

export const defaultList = [ 'smcTag' ];

export const filters = {
    smcTag: {},
    fullName: {},
};

export default filters;

export const filterTransfer = createFilterTransfer(filters, {});
export const filterParams = { filters, filterTransfer, defaultList, columnsTransfer: {} };
